import React, { Component } from 'react';

import { ContextualSurvey, SurveyMarshal } from '@atlaskit/contextual-survey';

import { IS_CLOUD } from '@qality/common-config';
import { UserPropertyService, UserService } from '@qality/common-service';

import './_feedback.scss';

/* example on how to create "onFeedbackSubmit" function
  import FeedbackService from 'unique/FeedbackService';

  const MANAGE_TEMPLATES_FEEDBACK = 'manageTemplates'; //name of property in .yml

  onFeedbackSubmit = async (feedback: any) => {
    let message = `Rating: ${feedback.rating}, Comment: ${feedback.comment}`;

    await FeedbackService.sendFeedback(MANAGE_TEMPLATES_FEEDBACK, message);
  };
*/

type Props = {
  question: string;
  statement: string;
  onFeedbackSubmit: (feedback: any) => void;
  surveyShowFlagVariableName: string;
  firstVisitFlagVariableName: string;
};

type State = {
  showSurvey: boolean;
  user: any;
};

export default class NpsFeedback extends Component<Props, State> {
  constructor() {
    super();
    this.state = {
      showSurvey: false,
      user: {},
    };
  }

  async componentDidMount() {
    if (!IS_CLOUD) {
      return;
    }

    const userTemp = await UserService.getCurrentUser();
    this.setState({
      user: userTemp,
    });

    const shouldShowPopup = await this.shouldShowPopup(userTemp);

    if (shouldShowPopup) {
      this.setState({
        showSurvey: true,
      });
    }
  }

  shouldShowPopup = async (user) => {
    let shouldShowPopup;
    try {
      const property = await UserPropertyService.getProperty(
        this.props.surveyShowFlagVariableName,
        user
      );
      shouldShowPopup = property.value?.showSurvey;
    } catch (e) {
      if (e.xhr.status === 404) {
        shouldShowPopup = await this.isNotFirstVisit(user);
      } else {
        shouldShowPopup = false;
      }
    }
    return shouldShowPopup;
  };

  isNotFirstVisit = async (user) => {
    let isNotFirstVisit;
    try {
      const property = await UserPropertyService.getProperty(
        this.props.firstVisitFlagVariableName,
        user
      );
      isNotFirstVisit = property.value?.isNotFirstVisit;
    } catch (e2) {
      if (e2.xhr.status === 404) {
        this.setProperty(this.props.firstVisitFlagVariableName, {
          isNotFirstVisit: true,
        });
      }
      isNotFirstVisit = false;
    }
    return isNotFirstVisit;
  };

  onFeedbackSubmit = (formValues) => {
    this.props.onFeedbackSubmit(formValues);
    this.setProperty(this.props.surveyShowFlagVariableName, {
      showSurvey: false,
    });
    setTimeout(() => {
      this.setState({
        showSurvey: false,
      });
    }, 2000);
  };

  onClose = () => {
    this.setProperty(this.props.surveyShowFlagVariableName, {
      showSurvey: false,
    });
    this.setState({
      showSurvey: false,
    });
  };

  setProperty = (propertyName: string, value: any) => {
    try {
      UserPropertyService.setProperty(propertyName, value, this.state.user);
    } catch (_e) {
      // do nothing, we do not want to show warning here
    }
  };

  render() {
    return (
      <div className='feedback_container'>
        <SurveyMarshal shouldShow={this.state.showSurvey}>
          {() => (
            <ContextualSurvey
              question={this.props.question}
              statement={this.props.statement}
              onDismiss={this.onClose}
              getUserHasAnsweredMailingList={() => true}
              onMailingListAnswer={() => undefined}
              onSubmit={(formValues) => this.onFeedbackSubmit(formValues)}
            />
          )}
        </SurveyMarshal>
      </div>
    );
  }
}
